import { render } from "./ListeCouponPage.vue?vue&type=template&id=0f42f8be&ts=true"
import script from "./ListeCouponPage.vue?vue&type=script&lang=ts"
export * from "./ListeCouponPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__